import React from 'react';

function ScoreBoard({ score, timeElapsed }) {
  return (
    <div className="scoreboard">
      <div className="score-container">
        <h3>Pontuação</h3>
        <div className="score">{score}</div>
      </div>
      <div className="time-container">
        <h3>Tempo</h3>
        <div className="time">{timeElapsed}s</div>
      </div>
    </div>
  );
}

export default ScoreBoard;
